export default __webpack_public_path__ + "static/media/1c7f1a5f9093e6b1dbefb4dcc62048581580819539299.1fbefda2.webp";